import { useMemo } from 'react'
import { getCookie } from '@chilecompra/react-kit/storages'
import { REACT_APP_ACCESS_TOKEN_NAME } from '../../config/settings/environment'

/**
 * Custom hook to get the access token.
 */
export const useAccessToken = () => {
  return useMemo(() => {
    const accessToken = getCookie(REACT_APP_ACCESS_TOKEN_NAME)

    // when the SSO service is down, the access token is a stringify null.
    if (!accessToken || accessToken === 'null') {
      return null
    }

    return accessToken
  }, [])
}
